import React from 'react';

export const PlaylistEmptyNoQueueIllustration: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="202"
			height="149"
			fill="none"
			viewBox="0 0 202 149"
		>
			<g filter="url(#a)">
				<rect
					width="163.436"
					height="110.043"
					x="19.216"
					y="16.014"
					fill="#fff"
					rx="6.006"
					shapeRendering="crispEdges"
				/>
				<rect width="105" height="8" x="31.227" y="32.028" fill="#f0f1f2" rx="4" />
				<rect width="10" height="10" x="31.227" y="45.033" fill="#f0f1f2" rx="5" />
				<rect width="34" height="4" x="45.227" y="48.033" fill="#f0f1f2" rx="2" />
				<path
					fill="#6b6e76"
					fillRule="evenodd"
					d="M32.165 72.538a4.063 4.063 0 0 0 8.125 0h.938a5 5 0 1 1-5-5v.937a4.063 4.063 0 0 0-4.063 4.063m2.866 1.27c.303.236.712.448 1.197.448.484 0 .893-.212 1.196-.448a2.7 2.7 0 0 0 .451-.446l.003-.005v.001l.38.273.382.273v.001l-.002.002-.003.005-.01.013a3 3 0 0 1-.16.192 3.7 3.7 0 0 1-.465.431c-.4.311-1.007.646-1.773.646-.765 0-1.372-.335-1.772-.646a3.7 3.7 0 0 1-.624-.623l-.01-.013-.004-.005-.001-.002s-.001-.001.38-.274l.382-.272-.001-.002.003.005.02.024a2.7 2.7 0 0 0 .432.422m-.21-1.583a.781.781 0 1 1 0-1.563.781.781 0 0 1 0 1.563m2.813 0a.781.781 0 1 1 0-1.563.781.781 0 0 1 0 1.563m1.406-2.5h-1.25v-.937h1.25v-1.25h.938v1.25h1.25v.937h-1.25v1.25h-.938z"
					clipRule="evenodd"
				/>
				<rect width="10" height="5" x="43.227" y="70.038" fill="#f0f1f2" rx="2.5" />
				<path
					fill="#6b6e76"
					d="M57.853 75.663v-7.5h.937v7.5c0 .172.14.312.313.312h7.5v.938h-7.5c-.69 0-1.25-.56-1.25-1.25"
				/>
				<path
					fill="#6b6e76"
					d="M66.603 72.225h-.938v-1.212l-2.325 2.325a.47.47 0 0 1-.663 0l-.918-.919-1.388 1.388-.662-.663 1.718-1.72.036-.031a.47.47 0 0 1 .627.032l.919.919 1.993-1.994H63.79v-.937h2.344c.259 0 .469.21.469.468z"
				/>
				<rect width="10" height="5" x="69.228" y="70.038" fill="#f0f1f2" rx="2.5" />
				<path
					fill="#6b6e76"
					fillRule="evenodd"
					d="M92.29 68.944v6.25h-3.594v-4.766c0-.82.665-1.484 1.485-1.484zm-4.062.052c.44-.6 1.151-.99 1.953-.99h2.188a.86.86 0 0 1 .859.86v6.406a.86.86 0 0 1-.86.86h-3.672v.937h-.937v-.938h-3.672a.86.86 0 0 1-.86-.86v-6.405a.86.86 0 0 1 .86-.86h2.187c.802 0 1.513.39 1.954.99m-.47 6.198v-4.766c0-.82-.664-1.484-1.484-1.484h-2.109v6.25zm3.75-5H89.79v.937h1.718zm0 1.562H89.79v.938h1.718z"
					clipRule="evenodd"
				/>
				<rect width="10" height="5" x="95.228" y="70.038" fill="#f0f1f2" rx="2.5" />
				<path
					fill="#6b6e76"
					fillRule="evenodd"
					d="M114.228 67.538c.194 0 .367.119.437.3l1.066 2.77 2.751.212a.47.47 0 0 1 .264.828l-2.113 1.76.782 2.914a.469.469 0 0 1-.718.508l-2.469-1.693-2.47 1.693a.469.469 0 0 1-.718-.508l.782-2.913-2.113-1.761a.468.468 0 0 1 .264-.828l2.751-.211 1.066-2.77a.47.47 0 0 1 .438-.301m0 1.774-.841 2.186-2.191.168 1.687 1.407-.608 2.267 1.953-1.34 1.952 1.34-.608-2.267 1.687-1.407-2.191-.168z"
					clipRule="evenodd"
				/>
				<rect width="10" height="5" x="124.228" y="70.038" fill="#f0f1f2" rx="2.5" />
				<path
					fill="#e9f2fe"
					d="M133.228 62.788c5.384 0 9.75 4.365 9.75 9.75s-4.366 9.75-9.75 9.75-9.75-4.366-9.75-9.75 4.365-9.75 9.75-9.75"
				/>
				<path
					stroke="#1868db"
					strokeWidth=".5"
					d="M133.228 62.788c5.384 0 9.75 4.365 9.75 9.75s-4.366 9.75-9.75 9.75-9.75-4.366-9.75-9.75 4.365-9.75 9.75-9.75Z"
				/>
				<path
					fill="#1868db"
					d="M134.946 71.913v1.406h1.407v.937h-1.407v1.407h-.937v-1.407h-1.406v-.937h1.406v-1.406z"
				/>
				<path
					fill="#1868db"
					d="M130.727 71.678c0-.906.734-1.64 1.64-1.64h2.533l-.213-1a.7.7 0 0 0-.833-.542l-4.127.877a.7.7 0 0 0-.541.834l.877 4.126a.7.7 0 0 0 .664.556zm.937 4.219c0 .388.315.703.703.703h4.219a.703.703 0 0 0 .703-.703v-4.22a.703.703 0 0 0-.703-.702h-4.219a.703.703 0 0 0-.703.703zm6.563 0a1.64 1.64 0 0 1-1.641 1.64h-4.219a1.64 1.64 0 0 1-1.64-1.64v-.07a1.64 1.64 0 0 1-1.582-1.299l-.877-4.127a1.64 1.64 0 0 1 1.264-1.945l4.126-.877a1.64 1.64 0 0 1 1.947 1.264l.254 1.194h.727c.906 0 1.641.735 1.641 1.64z"
				/>
				<g fill="#101214" clipPath="url(#b)">
					<path d="M141.483 61.63c-.064.147.354.594.506.54.214-.076.408-.19.619-.38.214-.239.186-.387.355-.523.268-.252.836-.549.976-.62a.2.2 0 0 0 .052-.042c.1-.124.544-.664 1.009-1.04l.596-.56c.232-.224.366-.432.459-.68.051-.134-.312-.524-.451-.483a1.8 1.8 0 0 0-.709.41c-.092.085-.383.155-.669.388a.4.4 0 0 0-.111.143c-.238.496-.764.908-.764.908l-1.035.962-.409.385a1.8 1.8 0 0 0-.422.59zm-4.196-1.291c.01.16.587.366.699.249.155-.166.275-.358.375-.623.08-.312-.012-.43.074-.63.123-.346.491-.872.581-.997a.2.2 0 0 0 .028-.061c.032-.156.177-.84.419-1.388l.273-.772c.103-.305.126-.552.096-.813-.017-.143-.52-.323-.623-.222a1.8 1.8 0 0 0-.442.69c-.043.119-.268.315-.417.653a.4.4 0 0 0-.033.178c.015.55-.26 1.16-.26 1.16l-.478 1.328-.186.53a1.8 1.8 0 0 0-.104.72zm7.44 3.447c-.127.1.029.693.189.718.226.034.451.026.725-.041.303-.11.348-.253.561-.294.354-.094.996-.085 1.151-.083a.2.2 0 0 0 .065-.013c.148-.062.793-.327 1.382-.436.408-.11.66-.176.791-.211.31-.087.528-.207.727-.38.11-.095-.027-.61-.169-.638a1.8 1.8 0 0 0-.819.024c-.121.03-.41-.045-.773.023a.4.4 0 0 0-.166.074c-.446.321-1.103.437-1.103.437l-1.367.355c-.306.082-.452.122-.542.145-.272.076-.474.18-.654.32z" />
				</g>
				<rect width="139.414" height="4.182" x="31.227" y="90.042" fill="#f0f1f2" rx="2.091" />
				<rect width="139.414" height="4.182" x="31.227" y="99.801" fill="#f0f1f2" rx="2.091" />
				<rect width="139.414" height="4.182" x="31.227" y="109.56" fill="#f0f1f2" rx="2.091" />
			</g>
			<defs>
				<clipPath id="b">
					<path fill="#fff" d="m138.05 54.82 13.232 1.917-1.234 8.51-13.231-1.917z" />
				</clipPath>
				<filter
					id="a"
					width="201.869"
					height="148.476"
					x="0"
					y="0"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3.203" />
					<feGaussianBlur stdDeviation="9.608" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0.0941176 0 0 0 0 0.407843 0 0 0 0 0.858824 0 0 0 0.16 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6959_85286" />
					<feBlend in="SourceGraphic" in2="effect1_dropShadow_6959_85286" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};
